import {
  AfterViewInit,
  Component,
  ComponentFactory,
  ComponentFactoryResolver, ComponentRef,
  Inject,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DialogData} from '../dialogController';
import {IDialogComponent} from '../iDialog.component';
import {DialogWithInput} from '../dialogWithInput';
import {Dialog} from '../dialog';

@Component({
  selector: 'app-dialog-wrapper',
  templateUrl: './dialog-wrapper.component.html',
})
export class DialogWrapperComponent<R, DialogInput, T extends IDialogComponent<DialogInput, R>> implements AfterViewInit {

  @ViewChild('content', {read: ViewContainerRef}) container: ViewContainerRef;
  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: DialogData<R, DialogInput, T>,
              private dialogRef: MatDialogRef<any>,
              private componentFactoryResolver: ComponentFactoryResolver) { }

  ngAfterViewInit(): void {
    const componentFactory: ComponentFactory<T> = this.componentFactoryResolver.resolveComponentFactory(this.dialogData.componentType);
    const component: ComponentRef<T> = this.container.createComponent(componentFactory);
    component.instance.dialog = new DialogWithInput<DialogInput, R>(
        this.dialogData.customData,
        this.dialogData.options,
        new Dialog<R>(this.dialogRef)
    );
  }

}
